module.exports = __webpack_public_path__ + "static/media/BasierCircle-SemiBold.a9742b50.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Basier Circle/Web/BasierCircle-SemiBold.woff2
// module id = 6543
// module chunks = 1